export default __webpack_public_path__ + "static/media/promos_pasada-Raceweek-Silverstone.6de20308.webp";